<template>
  <toolbar-container>
    <template #toolbar>
      <reports-toolbar />
    </template>

    <v-row class="pa-3 ma-0">
      <v-col
        class="pa-0 ma-0 mb-3 mb-md-0 pr-sm-3"
        cols="12"
        sm="6"
        md="3"
      >
        <mini-data-chart
          :title="$t('label.report_returning_guest')"
          :category-type="returning.categoryType"
          :category="returning.category"
          :series="compareSeries"
          :dataset="returning.dataset"
          :totals="returning.totals"
        />
      </v-col>
      <v-col
        class="pa-0 ma-0 mb-3 mb-md-0 pr-md-3"
        cols="12"
        sm="6"
        md="3"
      >
        <mini-data-chart
          :title="$t('label.report_cancellation')"
          :category-type="cancellations.categoryType"
          :category="cancellations.category"
          :series="compareSeries"
          :dataset="cancellations.dataset"
          :totals="cancellations.totals"
          inverse-metric
        />
      </v-col>
      <v-col
        class="pa-0 ma-0 mb-3 mb-sm-0 pr-sm-3"
        cols="12"
        sm="6"
        md="3"
      >
        <mini-data-chart
          :title="$t('label.report_noshows')"
          :category-type="noshows.categoryType"
          :category="noshows.category"
          :series="compareSeries"
          :dataset="noshows.dataset"
          :totals="noshows.totals"
          inverse-metric
        />
      </v-col>
      <v-col
        class="pa-0 ma-0"
        cols="12"
        sm="6"
        md="3"
      >
        <mini-data-chart
          :title="$t('label.report_avg_partysize')"
          :category-type="partySizes.categoryType"
          :category="partySizes.category"
          :series="compareSeries"
          :dataset="partySizes.dataset"
          :totals="partySizes.totals"
          unit=""
        />
      </v-col>
      <v-col
        cols="12"
        class="mt-3 pa-0 ma-0 mb-0"
      >
        <simple-line-chart
          v-if="compare"
          :title="$t('label.guests')"
          :category-type="guests.categoryType"
          :category="guests.category"
          :series="compareSeries"
          :dataset="guests.dataset"
          :totals="guests.totals"
          compare
        />
        <stacked-line-chart
          v-else
          :title="$t('label.report_guests_per_source')"
          :category-type="campaignGuests.categoryType"
          :category="campaignGuests.category"
          :series="campaignGuests.series"
          :dataset="campaignGuests.dataset"
          :total="campaignGuests.total"
        />
      </v-col>
      <v-col
        class="pa-0 ma-0 mt-3"
        cols="12"
      >
        <simple-line-chart
          v-if="compare"
          :title="$t('label.reservations')"
          :category-type="reservations.categoryType"
          :category="reservations.category"
          :series="compareSeries"
          :dataset="reservations.dataset"
          :totals="reservations.totals"
          compare
        />

        <stacked-line-chart
          v-else
          :title="$t('label.report_reservations_per_source')"
          :category-type="campaignReservations.categoryType"
          :category="campaignReservations.category"
          :series="campaignReservations.series"
          :dataset="campaignReservations.dataset"
          :total="campaignReservations.total"
        />
      </v-col>
    </v-row>
  </toolbar-container>
</template>

<script lang="ts">

import Vue from 'vue';

import SimpleLineChart from '@/components/views/reports/SimpleLineChart.vue';
import StackedLineChart from '@/components/views/reports/StackedLineChart.vue';
import MiniDataChart from '@/components/views/reports/MiniDataChart.vue';
import ReportsToolbar from '@/components/views/reports/ReportsToolbar.vue';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import ReportsStore from '@/store/reports-store';
import { ChartData } from '@/services/reports-utils';
import { ReportsType } from '@/services/reports';

export default Vue.extend({
  name: 'ReportReservations',
  components: {
    SimpleLineChart,
    MiniDataChart,
    ReportsToolbar,
    StackedLineChart,
  },
  data() {
    return {};
  },
  computed: {
    compare(): boolean { return this.$tstore.getters.reportsComparePrevious; },
    reservations(): ChartData { return this.$tstore.getters.reportsReservations; },
    guests(): ChartData { return this.$tstore.getters.reportsGuests; },
    campaignReservations(): ChartData { return this.$tstore.getters.reportsCampaignsReservations; },
    campaignGuests(): ChartData { return this.$tstore.getters.reportsCampaignsGuests; },
    returning(): ChartData { return this.$tstore.getters.reportsReturning; },
    cancellations(): ChartData { return this.$tstore.getters.reportsCancelations; },
    noshows(): ChartData { return this.$tstore.getters.reportsNoshows; },
    partySizes(): ChartData { return this.$tstore.getters.reportsPartySizes; },
    compareSeries(): string[] {
      return this.compare
        ? [this.$i18n.tc('label.report_this_period'), this.$i18n.tc('label.report_previous_period')]
        : [this.$i18n.tc('label.report_this_period')];
    },
  },
  created() {
    loadStoreModule(this, 'reports', ReportsStore, async () => {
      this.$tstore.dispatch('updateReports', { reportsType: ReportsType.Reservations });
    });
  },
  beforeDestroy() {
    unloadStoreModule(this, 'reports', async () => { this.$tstore.dispatch('resetReports'); });
  },
  methods: {},
});

</script>
